import { CenteredSpinner } from '@wyz/ui';
import React, { useMemo } from 'react';
import { useManageCriteria } from '~/common/api';

// eslint-disable-next-line @wyz/module/no-relative-import
import { FormContext, IFormContext } from './contexts';

function RedistributionPricingPolicyFormProvider({
  children,
}: React.PropsWithChildren) {
  const manageCriteria = useManageCriteria({ getAll: { enabled: true } });

  const context: IFormContext = useMemo(() => {
    return {
      criteria: {
        ...manageCriteria.getAll,
        optionItems: manageCriteria.getAll.data?.data ?? [],
      },
    } satisfies IFormContext;
  }, [manageCriteria.getAll]);

  const requiredQueries = [manageCriteria.getAll];
  return (
    <FormContext.Provider value={context}>
      {requiredQueries.some((query) => !query.isSettled) && <CenteredSpinner />}
      {requiredQueries.every((query) => query.isSuccess) && children}
    </FormContext.Provider>
  );
}
export const useRedistributionPricingPolicyForm = () => {
  const context = React.useContext(FormContext);
  if (context === undefined) {
    throw new Error(
      'useRedistributionPricingPolicyForm must be used within a RedistributionPricingPolicyFormProvider',
    );
  }
  return context;
};

export default RedistributionPricingPolicyFormProvider;
